// GA4 이벤트 전송 헬퍼 (클라이언트 전용). gtag 미로드(개발·GA_ID 없음) 시 무시.
//   전환(주요 이벤트)·사이트검색 등을 코드에서 직접 전송.
type GtagParams = Record<string, string | number | boolean | undefined>;

export function trackEvent(name: string, params: GtagParams = {}): void {
  if (typeof window === "undefined") return;
  const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
  if (typeof g !== "function") return;
  g("event", name, params);
}
